jQuery(function ($) {

    // if($('body').hasClass('is_localhost')) {
    //     return false;
    // }

    jQuery
        .ajax({
            type: "POST",
            dataType: "json",
            url: header_banner_ajax.ajaxurl,
            data: {
                action: "header_banner_top_ajax",
            },
            async: true,
            success: function (data) { },
        })
        .done(function (data) {
            var $data = jQuery(data);
            if ($data[0].html.length) {
                jQuery(".header-banners-container-top .header-banners").html($data[0].html);
                set_banner_header_spacing();
            }
        });

    jQuery
        .ajax({
            type: "POST",
            dataType: "json",
            url: header_banner_ajax.ajaxurl,
            data: {
                action: "header_banner_bottom_ajax",
            },
            async: true,
            success: function (data) { },
        })
        .done(function (data) {
            var $data = jQuery(data);
            if ($data[0].html.length) {
                jQuery(".header-banners-container-bottom .header-banners").html($data[0].html);
                set_banner_header_spacing();
            }
        });
});